export const AUTH = 'auth';
export const WORKER = 'worker';
export const WHITELABEL = 'whitelabel';
export const AUTH_GENERAL = 'auth/general';
